import { GridCol, GridRow, Icon, ICONS } from '@bob/library'
import { Asset } from '@websrc/App/Components/Asset/Asset'
import { useStaticText } from '@websrc/App/Hooks/useStaticText'
import { mapBuildingInstruction } from '@websrc/DataMappers/mapBuildingInstruction'
import React from 'react'

import * as SC from './BuildingInstruction.style'

export interface BuildingInstructionProps {
  bi: ReturnType<typeof mapBuildingInstruction>
}

export const BuildingInstruction = ({ bi }: BuildingInstructionProps) => {
  const t = useStaticText()
  const { buildingInstructions, title } = bi

  return (
    <GridRow>
      <GridCol>
        <h2>{title}</h2>
      </GridCol>

      {buildingInstructions.map(
        (b, i) =>
          b?.pdf && (
            <GridCol giant={4} key={`${b.title}${i}`} tablet={6}>
              <a download={true} href={b.pdf.url} rel={'noopener noreferrer'} target={'_blank'}>
                <SC.StyledTitle>{b.title}</SC.StyledTitle>
                <SC.ButtonTertiary>
                  <Icon icon={ICONS.DOWNLOAD} size={20} />
                  <span>{t.global.download}</span>
                </SC.ButtonTertiary>
                {b.thumbnail && (
                  <Asset
                    sizes={'(min-width: 1024px) 600px'}
                    srcSetWidths={[320, 400, 600, 800, 1200]}
                    thumbnail={b.thumbnail}
                  />
                )}
              </a>
            </GridCol>
          )
      )}
    </GridRow>
  )
}
